import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const MessageNotificationIcon = () => (
  <FontAwesomeIcon className="fs-16 pointer" color="#33AAFC" icon={['far', 'comment-alt-lines']} />
);

export default MessageNotificationIcon;
